/**
 * @author: lv.chen
 * @date: 2025/10/15
 * @desc: Calibration Metrics Switcher切换按钮组件
 */
import React from 'react';
import classnames from 'classnames';
import { BubbleProps } from 'tea-component';
import { Bubble } from '@home/components/TeaComponents';
import { useIntl } from 'umi';
import { useDebounceFn } from 'ahooks';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';

import './index.scss';

interface ICalibrationMetricsSwitcherProps extends IBaseProps {
  disabled?: boolean;
  bubblePlacement?: BubbleProps['placement'];
  bubbleContent?: string;
  onSwitch?: () => void;
}

const CalibrationMetricsSwitcher: React.FC<ICalibrationMetricsSwitcherProps> = (props) => {
  const { style, className, disabled = false, bubblePlacement, bubbleContent, onSwitch } = props;

  const { formatMessage } = useIntl();

  const { run: handleSwitchRun } = useDebounceFn(
    () => {
      onSwitch?.();
    },
    { wait: 1000, leading: true, trailing: false },
  );

  return (
    <Bubble dark arrowPointAtCenter placement={bubblePlacement} content={bubbleContent}>
      <div
        style={style}
        className={classnames('dbi-calibration-metrics-switcher', className, {
          'dbi-calibration-metrics-switcher--disabled': disabled,
        })}
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) {
            handleSwitchRun();
          }
        }}
      >
        <img className="dbi-calibration-metrics-switcher__icon" src={getDataSourceIcon('databrainbluebg')} alt="" />
        <span className="dbi-calibration-metrics-switcher__text">
          {formatMessage({ id: 'dbi_top_calibration_metrics_switcher_text' })}
        </span>
      </div>
    </Bubble>
  );
};

export default CalibrationMetricsSwitcher;
